import {call, fork, put, takeEvery} from "@redux-saga/core/effects";
import {getToken, logout, signIn} from "../../../api/login/api";
import {getTokenSuccess, loginError, loginSuccess} from "../../actions/login/actions";
import {loginTypes} from "../../actions/login/types";
import {initializeApp} from "firebase/app";
import {getMessaging} from "firebase/messaging";
import {firebaseConfig} from "../../../common/config-variable/notification";
import {message} from "antd";
import Cookies from "js-cookie";
import {BASE_DOMAIN, BASE_HOME} from "../../../custom/axios/config/Url";
import {t} from "i18next";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

function* onLoginStartAsync(action) {
    try {
        const {username, password, rememberMe} = action;

        const responseOauth2 = yield call(getToken);

        if (responseOauth2.status === 200) {
            yield put(getTokenSuccess(responseOauth2.data));
            localStorage.setItem("oauth2Token", JSON.stringify(responseOauth2.data));
        }

        const response = yield call(
            signIn,
            username,
            password,
            rememberMe
        )
        if (response.status === 200) {
            localStorage.setItem("accessToken", response.data.accessToken);
            Cookies.set("accessToken", response.data.accessToken, {expires: 2592})

            const newOauth2 = yield call(getToken);
            if (responseOauth2.status === 200) {
                yield put(getTokenSuccess(newOauth2.data));
                localStorage.setItem("oauth2Token", JSON.stringify(newOauth2.data));
            }
            yield put(loginSuccess());

        }
    } catch (error) {
        yield put(loginError(error?.response?.data));
        message.error(t("notification.loginFailed"));
    }
}

function* onLogin() {
    yield takeEvery(loginTypes.REQUEST, onLoginStartAsync);
}

function* onLogoutStartAsync() {
    try {
        yield call(logout);
    } finally {
        const deviceLang = window.localStorage.getItem('lang') || 'vi';
        Cookies.remove("accessToken", {domain: BASE_DOMAIN});
        window.localStorage.clear();
        window.localStorage.setItem('lang', deviceLang);
        Cookies.set("language", deviceLang, {expires: 30, domain: BASE_DOMAIN});
        const pathname = encodeURIComponent(`${document.location.href}`);
        window.location.href = `${BASE_HOME}login?redirect=${pathname.replaceAll("403", "")}`;
    }
}

function* onLogout() {
    yield takeEvery(
        loginTypes.LOGOUT,
        onLogoutStartAsync
    );
}

const login = [fork(onLogin), fork(onLogout)];

export default login;
